enum NotificationsActions {
  Push = 0,
  Close = 1,
}

export default NotificationsActions
